import React, { useEffect, useState } from "react";

// tiny CSS person: head + body + swinging legs
const Person = ({ skin = "#e0a072", shirt = "#457B9D", pant = "#3a3a3a", h = 26, walking = false }) => (
  <div className="relative" style={{ width: h * 0.5, height: h }}>
    <span className="absolute left-1/2 top-0 -translate-x-1/2 rounded-full" style={{ width: h * 0.32, height: h * 0.32, background: skin }} />
    <span className="absolute left-1/2 top-[30%] -translate-x-1/2 rounded-sm" style={{ width: h * 0.42, height: h * 0.4, background: shirt }} />
    <span className={`absolute left-[22%] top-[68%] origin-top rounded ${walking ? "npc-legs" : ""}`} style={{ width: h * 0.14, height: h * 0.32, background: pant }} />
    <span className={`absolute right-[22%] top-[68%] origin-top rounded ${walking ? "npc-legs" : ""}`} style={{ width: h * 0.14, height: h * 0.32, background: pant, animationDelay: "0.2s" }} />
  </div>
);

const Bubble = ({ text }) => (
  <div className="speech-bubble absolute -top-6 left-1/2 -translate-x-1/2 whitespace-nowrap rounded-md border-2 border-kirana-brown bg-kirana-cream px-1.5 py-[1px] font-signboard text-[8px] font-bold text-kirana-brown shadow-[1px_1px_0_rgba(0,0,0,0.3)]">
    {text}
    <span className="absolute -bottom-[5px] left-1/2 h-2 w-2 -translate-x-1/2 rotate-45 border-b-2 border-r-2 border-kirana-brown bg-kirana-cream" />
  </div>
);

const CRICKET = ["OUT hai be!", "Nahi hai!", "Ek tip ek hand!", "Last ball!", "Bat de na!", "Ball meri hai!"];
const GENERAL = ["Arre beta!", "Chal ghar!", "Bas 5 minute aur!", "Doodh le aao.", "Sabzi le lo!", "Cricket kheloge?", "Der ho rahi hai!", "Mummy bula rahi hai!", "Sunday hai bhai!"];

// A speech bubble that pops on one of the NPCs every few seconds.
const useRandomChatter = (count) => {
  const [who, setWho] = useState(-1);
  const [text, setText] = useState("");
  useEffect(() => {
    let alive = true;
    const tick = () => {
      if (!alive) return;
      const idx = Math.floor(Math.random() * count);
      const pool = idx <= 1 ? CRICKET : GENERAL;
      setWho(idx);
      setText(pool[Math.floor(Math.random() * pool.length)]);
      setTimeout(() => alive && setWho(-1), 3000);
    };
    const iv = setInterval(tick, 4200 + Math.random() * 2600);
    const t0 = setTimeout(tick, 1500);
    return () => { alive = false; clearInterval(iv); clearTimeout(t0); };
  }, [count]);
  return { who, text };
};

// Non-interactive animated street life. Bubbles at slots 0/1 = cricket kids.
export const StreetNPCs = () => {
  const { who, text } = useRandomChatter(8);
  return (
    <div className="pointer-events-none absolute inset-0 z-[13] overflow-hidden">
      {/* 0: cricket batsman */}
      <div className="absolute" style={{ bottom: "9%", right: "22%" }}>
        {who === 0 && <Bubble text={text} />}
        <div className="relative"><Person skin="#e0a072" shirt="#E63946" pant="#2b3a67" h={26} />
          <span className="bat-swing absolute -right-2 top-2 h-6 w-1.5 rounded-sm bg-[#9C6644]" />
        </div>
      </div>
      {/* 1: cricket bowler + ball lob */}
      <div className="absolute" style={{ bottom: "9%", right: "40%" }}>
        {who === 1 && <Bubble text={text} />}
        <Person skin="#c98a5b" shirt="#2A9D8F" pant="#333" h={24} />
        <span className="ball-lob absolute -top-1 left-0 h-2 w-2 rounded-full bg-[#c1e34a]" />
      </div>
      {/* 2: skipping rope girl */}
      <div className="absolute" style={{ bottom: "10%", left: "28%" }}>
        {who === 2 && <Bubble text={text} />}
        <div className="rope-jump"><Person skin="#e0a072" shirt="#E76F51" pant="#6a3f8c" h={22} /></div>
        <span className="rope-swing absolute -left-2 top-1 h-6 w-6 rounded-full border-2 border-[#3a2617]" />
      </div>
      {/* 3: kid cycling across the road (loops) */}
      <div className="gali-walk-r absolute" style={{ bottom: "13%", animationDuration: "11s" }}>
        {who === 3 && <Bubble text={text} />}
        <div className="relative h-6 w-9">
          <span className="absolute bottom-0 left-0 h-4 w-4 rounded-full border-2 border-[#3a2617]" />
          <span className="absolute bottom-0 right-0 h-4 w-4 rounded-full border-2 border-[#3a2617]" />
          <span className="absolute bottom-2 left-2 h-3 w-4 -rotate-6 bg-[#457B9D]" />
          <span className="absolute -top-1 left-3 h-2.5 w-2.5 rounded-full bg-[#e0a072]" />
        </div>
      </div>
      {/* 4: milkman on cycle (other way, slower) */}
      <div className="gali-walk-l absolute" style={{ bottom: "16%", animationDuration: "17s" }}>
        {who === 4 && <Bubble text={text} />}
        <div className="relative h-6 w-10">
          <span className="absolute bottom-0 left-0 h-4 w-4 rounded-full border-2 border-[#3a2617]" />
          <span className="absolute bottom-0 right-0 h-4 w-4 rounded-full border-2 border-[#3a2617]" />
          <span className="absolute bottom-2 left-2 h-3 w-5 bg-[#e8e4dc]" />
          <span className="absolute bottom-4 right-1 h-3 w-2 rounded bg-[#dfe3e8]" />
          <span className="absolute -top-1 left-3 h-2.5 w-2.5 rounded-full bg-[#c98a5b]" />
        </div>
      </div>
      {/* 5 & 6: two aunties gossiping */}
      <div className="absolute" style={{ bottom: "20%", left: "72%" }}>
        {who === 5 && <Bubble text={text} />}
        <div className="flex items-end gap-1">
          <div className="npc-bob"><Person skin="#d69a68" shirt="#2D6A4F" pant="#7a2f5a" h={24} /></div>
          <div className="npc-bob" style={{ animationDelay: "0.25s" }}><Person skin="#e0a072" shirt="#C84B31" pant="#3a3a6a" h={24} /></div>
        </div>
      </div>
      {/* 7: uncle walking home with groceries (loops) */}
      <div className="gali-walk-l absolute" style={{ bottom: "9%", animationDuration: "22s" }}>
        {who === 7 && <Bubble text={text} />}
        <div className="relative">
          <Person skin="#c98a5b" shirt="#e8e4dc" pant="#3a3a3a" h={26} walking />
          <span className="absolute -right-2 top-4 h-3 w-3 rounded-sm bg-[#E9C46A]" />
        </div>
      </div>
      {/* street dog with wagging tail */}
      <div className="absolute" style={{ bottom: "6%", left: "48%" }}>
        <div className="relative h-4 w-8">
          <span className="absolute bottom-0 left-0 h-3 w-6 rounded-md bg-[#8a5a34]" />
          <span className="absolute bottom-1 -left-1 h-2.5 w-2.5 rounded-full bg-[#8a5a34]" />
          <span className="dog-wag absolute bottom-2 right-0 h-[2px] w-3 rounded bg-[#8a5a34]" />
          <span className="absolute bottom-0 left-1 h-2 w-[2px] bg-[#6e4526]" />
          <span className="absolute bottom-0 right-1 h-2 w-[2px] bg-[#6e4526]" />
        </div>
      </div>
    </div>
  );
};
